export default __webpack_public_path__ + "static/media/support-allied-nabil-attar.58902bd4.png";